module.exports = __webpack_public_path__ + "static/media/8OLA2.431558bd.jpg";